import { MoveApiModel } from '@app/api/api-models/MoveApiModel';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CreateItemApiModel } from '@app/api/api-models/CreateItemApiModel';
import { FormApiModel, FormListApiModel } from '@app/api/api-models';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class FormsService {
  public apiUrl = 'forms';

  constructor(private readonly http: HttpClientService) {}

  public getList(): Observable<FormListApiModel[]> {
    return this.http.get<FormListApiModel[]>(`${this.apiUrl}/get-list`);
  }
  public getMultipleTraineesEnabled(): Observable<FormListApiModel[]> {
    return this.http.get<FormListApiModel[]>(`${this.apiUrl}/get-multiple-trainees-enabled`);
  }

  public getById(id: number): Observable<FormApiModel> {
    return this.http.get<FormApiModel>(`${this.apiUrl}/get/${id}`).pipe(map((x) => new FormApiModel().deserialize(x)));
  }

  public add(model: CreateItemApiModel): Observable<FormApiModel> {
    return this.http.post<FormApiModel>(`${this.apiUrl}/create`, model);
  }

  public move(model: MoveApiModel<number>): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/move`, model);
  }

  public update(model: FormApiModel): Observable<FormApiModel> {
    return this.http
      .put<FormApiModel>(`${this.apiUrl}/update`, model)
      .pipe(map((x) => new FormApiModel().deserialize(x)));
  }

  public delete(model: FormApiModel): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/delete/${model.Id}`);
  }
}
